<template>
  <div class="demo-spin-article">
    <div class="ls_action_header">
      <Row class="ls_action_header mb-24" style="padding: 5px" type="flex" justify="space-between">

        <Col :xs="24" :sm="24" :md="24" :lg="0">
          <Row type="flex" :gutter="24">
            <!-- TEXT SEARCH -->
            <Col :xs="24" :sm="24" :md="24" :lg="0">
              <Input
                placeholder="Введите номер документа"
                class="search-input mb-10"
                v-model="searchString"
              >
                <Icon type="ios-search" slot="suffix" />
              </Input>

            </Col>

            <Col :xs="24" :sm="12" :md="12" :lg="0">
              <Select
                class="mb-10 select-box"
                v-model="filter.type"
                clearable
                placeholder="Тип"
              >
                <Option
                  v-for="item in filterOptions.type"
                  :value="item.value"
                  :key="item.value"
                >{{ item.label }}
                </Option>
              </Select>
            </Col>

            <Col :xs="24" :sm="12" :md="12" :lg="0">
              <Select
                class="mb-10 select-box"
                v-model="filter.applied"
                clearable
                placeholder="Статус"
              >
                <Option
                  v-for="item in filterOptions.applied"
                  :value="item.value"
                  :key="item.value"
                >{{ item.label }}
                </Option>
              </Select>
            </Col>

          </Row>
        </Col>

        <Col :xs="24" :sm="24" :md="24" :lg="0">
          <DatePicker
          v-model="filterOrderDate"
          @on-change="changeFilterOrderDate"
          @on-clear="clearFilterOrderDate"
          format="dd.MM.yyyy"
          type="daterange"
          :start-date="currentDate"
          placeholder="Дата документа"
        ></DatePicker></Col>

      </Row>

      <Row class="mb-15">
        <Button v-if="showClearFilter"
                @click="clearFilter"
                type="error"
        >Сбросить фильтр</Button>
      </Row>

    </div>
    <!-- DATA TABLE + PAGINATION -->
    <Table
      class="desktop_table"
      :loading="loading"
      :columns="columns"
      :data="data"
      @on-sort-change="changeSorting"
      @on-selection-change="onSelectChange"
    ></Table>

    <!-- DATA MOBILE TABLE -->
    <div class="mobile-table">

      <router-link :to="'/mdocs/detail/' + item.id" v-for="item in data" class="card-container">
        <div>
          <h2>{{item.name}}</h2>
          <p>Статус:
            <span v-if="item.applied === true">Проведен</span>
            <span v-else>Не проведен</span>
          </p>
          <p>Дата документа: {{formatDateTime(item.order_date)}}</p>
          <p>Контрагент: {{item.counterpart.name}}</p>
          <p>Счет: {{item.account_ext.name}} </p>
          <p>Категория: {{item.category_display}} </p>
          <p>Товарный документ: {{item.product_order_name}} </p>
          <p>Пользователь: {{item.created_by}} </p>
        </div>

        <div>
          <p class="price">{{item.sum}} {{currency}}</p>
        </div>

      </router-link>
    </div>
    <Page
      :total="totalRecords"
      :page-size="pageSize"
      :page-size-opts="[15,25,35]"
      @on-change="changePage"
      @on-page-size-change="changePageSize"
      show-sizer
      :styles="{ marginTop: '30px', float: 'right' }"
    />

    <!-- ITEM VIEW -->
    <moneyOrderItem
      :id="item.id"
      :action="item.action"
      v-model="item.show"
      @reload-table="fetchItems"
      :base_view_url="baseViewUrl"
      :item_type="item_type"
    ></moneyOrderItem>


    <drawersCommon :item="drawerItem"></drawersCommon>

  </div>
</template>
<script>
import { base_url } from "../../http.js";
import { BaseTableData } from "../../base/base_table.js";
import moneyOrderItem from "@/apps/money_order/moneyOrderItem.vue";
import {getCounterpartTypeLabel, getRouteNameByCounterpartType} from "../money_order/func";
import drawersCommon from "@/apps/partial/drawers.vue";

let _app = BaseTableData();
_app.components = {
  moneyOrderItem,
    drawersCommon
};
_app.data = function() {
  return {
    // Base settings
    baseViewUrl: base_url + "/money_orders/",
    item_type: "money_order",
    loading: true,

      drawerItem: {
          show: false,
          id: null,
          type: null
      },

    // Table settings
    columns: [
      // {
      //   type: "selection",
      //   width: 60,
      //   align: "center"
      // },
      {
        title: "Документ",
        maxWidth: 400,
        key: "name",
        // sortable: true,
        render: (h, params) => {
          return h(
            "router-link",
            {
              props: {
                to: {
                  name: this.item_type + "_detail",
                  params: { id: params.row.id }
                }
              }
            },
            params.row.name
          );
        }
      },
      {
        title: "Статус",
        maxWidth: 110,
        align: "center",
        key: "applied",
        render: (h, params) => {
          // console.log(params.row);
          if (params.row.applied) {
            return h(
              "tag",
              {
                props: {
                  color: "success"
                },
                  style: {
                      backgroundColor: "#ffffff", color: "#25D77E", fontSize: "15px", borderRadius: "20px"
                  },
              },
              "Проведен"
            );
          } else {
            return h(
              "tag",
              {
                props: {
                  color: "warning"
                },
                  style: {
                      backgroundColor: "#ffffff", color: "#ED4729", fontSize: "15px", borderRadius: "20px"
                  },
              },
              "Не проведен"
            );
          }
        }
      },
      {
        title: "Дата документа",
        // width: 80,
        align: "center",
        // key: "order_date_display",
        // sortable: true,
        render: (h, params) => {
          return h(
            "span",
            {},
            this.formatDateTime(params.row.order_date)
          );
        }
      },
      {
        title: "Сумма",
        key: "sum",
        align: 'center',
        sortable: true,
        render: (h, params) => {
          return h("div", {}, this.formatNumber(params.row.sum) + ' ' + this.currency);
        }
      },
      {
        title: "Контрагент",
        // width: 80,
        render: (h, params) => {
          let conuterpart_type_label = getCounterpartTypeLabel(params.row.counterpart.type);
          let routeName = getRouteNameByCounterpartType(params.row.counterpart.type);
          return h("div", {}, [
            h(
              "div",
              { style: { fontSize: "11px", color: "grey" } },
              conuterpart_type_label.toLowerCase()
            ),
              h("div", {
                      on: {
                          click: () => {
                              this.showDrawer(params.row.counterpart);
                          }
                      },
                      style: {
                          cursor: 'pointer'
                      }
                  },
                  params.row.counterpart.name
              ),
            // h(
            //   "router-link",
            //   {
            //     props: {
            //       to: {
            //         name: routeName,
            //         params: { id: params.row.counterpart.id }
            //       }
            //     }
            //   },
            //   params.row.counterpart.name
            // )
          ]);
        }
      },
      {
        title: "Счет",
        // width: 80,
        render: (h, params) => {
          return h("div", {}, [
            h(
              "div",
              { style: { fontSize: "11px", color: "grey" } },
              params.row.account_ext.type_display.toLowerCase()
            ),
            h(
              "router-link",
              // {
              //   props: {
              //     to: {
              //       name: 'account_detail',
              //       params: { id: params.row.account_ext.id }
              //     }
              //   }
              // },
              {
                props: {
                  to: {
                    name: this.item_type + "_detail",
                    params: { id: params.row.id }
                  }
                }
              },
              params.row.account_ext.name
            )
          ]);
        }
      },
      {
        title: "Категория",
        // width: 80,
        render: (h, params) => {
          return h("div", {}, [
            params.row.category_display
          ]);
        }
      },
      {
        title: "Товарный документ",
        // width: 80,
        render: (h, params) => {
          return h("div", {
                  on: {
                      click: () => {
                          this.showDrawer(params.row.product_order, 'product_order');
                      }
                  },
                  style: {
                      cursor: 'pointer'
                  }
              },
              params.row.product_order_name
          );

          //
          //   h(
          //   "router-link",
          //   {
          //     props: {
          //       to: {
          //         name: "product_order_detail",
          //         params: { id: params.row.product_order }
          //       }
          //     }
          //   },
          //   params.row.product_order_name
          // );
        }
      },
      {
        title: "Пользователь",
        // width: 60,
        align: "center",
        key: "created_by",
      },
      {
        title: "Действия",
        // key: 'action',
        width: 120,
        align: "center",
        render: (h, params) => {
          let buttons = [];
          if (this.display_edit_button_by_row(params.row)) {
            buttons.push(
              h(
                "Tooltip",
                {
                  props: {
                    content: "Редактировать"
                  }
                },
                [
                  h("Button", {
                    props: {
                      to: {
                        name: this.item_type + "_edit",
                        params: { id: params.row.id }
                      },
                      type: "primary",
                      size: "small",
                      // icon: 'ios-information-circle-outline',
                        icon: "md-create",
                    },
                      style: {
                          display: "flex", alignItems: "center", boxShadow: "none", background: "transparent", border: "none", color: "#DEDEDE",
                      },
                  })
                ]
              )
            );
          }

          // if (this.display_delete_button_by_row(params.row)) {
          // console.error(this.display_delete_button_by_row(params.row));
          if (this.display_delete_button_by_row(params.row)) {

            buttons.push(
              h(
                "Tooltip",
                {
                  props: {
                    content: "Удалить"
                  }
                },
                [
                  h("Button", {
                    props: {
                      size: "small",
                        icon: "md-trash",
                    },
                      style: {
                          display: "flex", alignItems: "center", boxShadow: "none", background: "transparent", border: "none", color: "#DEDEDE",
                      },
                    on: {
                      click: () => {
                        this.deleteItem(params.row.id);
                      }
                    }
                  })
                ]
              )
            );
          }
          return h("div", buttons);
        }
      }
    ],
    data: [],
    lastDraw: 0,
    totalRecords: null,
    currentPage: 1,
    pageSize: 15,
    sorting: "",
    searchString: "",
    // showClearFilter: false,

    filterShow: false,
    filter: {
      type: "",
      applied: "",
      order_date__gt: "",
      order_date__lt: "",
    },
    filterOptions: {
      type: [
        {
          value: "coming",
          label: "Приход"
        },
        {
          value: "outgoing",
          label: "Расход"
        }
      ],
      applied: [
        {
          value: "true",
          label: "Проведен"
        },
        {
          value: "false",
          label: "Не проведен"
        }
      ]
    },

    filterOrderDate: ['',''],
    selected: [],

    item: {
      show: false,
      id: null,
      action: null
    }
  };
};


_app.computed.currentDate = function(){
  let date = new Date();
  date.setMonth(date.getMonth() - 1);
  return date;
};



// Переключения режима "Доп.фильтр"
_app.methods.toogleFilter = function(val){
    this.filterShow = val;

    // Если убираем фильтр - очищаем все поля фильтра
    if (!val) {
      for (let key in this.filter) {
        this.filter[key] = "";
      }

      // Дополнительная очистка фильтров (Даты документа)
      this.filterOrderDate= [];
    }
};

// Очистка фильтров
_app.methods.clearFilter = function(val){
  // Очистка общих фильтров и посика
  if (this.searchString) {
    this.searchString = "";
  }
  for (let key in this.filter) {
    if (this.filter[key]) {
      this.filter[key] = "";
    }
  }

  // Дополнительная очистка фильтров (Даты документа)
  this.filterOrderDate= [];
};

_app.methods.changeFilterOrderDate = function(date_arr,date_obj){
  if (date_arr[0] && date_arr[1]) {
    this.filter.order_date__gt = this.filterOrderDate[0];
    this.filter.order_date__lt = this.filterOrderDate[1];

    // this.filter.order_date__gt = date_arr[0] + 'T00:00:00';
    // this.filter.order_date__lt = date_arr[1] + 'T00:00:00';
  }
};

// Очистка полей поиска даты документа (Order date), после чего срабатывает watcher и обновляются данные в таблице
_app.methods.clearFilterOrderDate = function(date_arr,date_obj){
  this.filter.order_date__gt = '';
  this.filter.order_date__lt = '';
};

_app.methods.initialRoute = function (route) {
  if (route.name === this.item_type + "_detail") {
    const id = route.params.id;
    this.detailView(id);
  } else if (route.name === this.item_type + "_edit") {
    const id = route.params.id;
    this.editView(id);
  } else if (route.name === this.item_type + "_create") {
    this.createView();
  } else if (route.name === this.item_type + "_create_transfer") {
    this.createTransferView();
  }
};

_app.methods.createTransferView = function () {
  // this.$router.push({name: 'customer_create'});
  this.item.id = null;
  this.item.action = "create_transfer";
  this.item.show = true;
};

//Открыть модальое окно и передать данные
_app.methods.showDrawer = function(item, type) {
    if(type) {
        this.drawerItem.id = item;
        this.drawerItem.type = type;
        this.drawerItem.show = true;
    }
    else {
        this.drawerItem.id = item.id;
        this.drawerItem.type = item.type;
        this.drawerItem.show = true;
    }
};


export default _app;
</script>

<style scoped>
  .search-input {
    width: 400px;
  }

  .select-box {
    min-width: 120px;
  }
  @media screen and (max-width: 1900px) {
    .search-input {
      width: 380px;
    }
  }

  @media screen and (max-width: 1500px) {
    .search-input {
      width: 380px;
    }
  }

  @media screen and (max-width: 991px) {
    .search-input {
      width: 100%;
    }

    .datepicker_input, .ivu-date-picker {
      width: 100%;
    }

  }

</style>


<style>
  .datepicker_input {
    width: 220px;
  }


  @media screen and (min-width: 992px) {
    .ivu-col-span-lg-0 {
      display: block;
      width: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/apps/money_order/moneyOrder.vue